module.exports = __webpack_public_path__ + "img/roar_film.39f7d3b6.jpg";